// extracted by mini-css-extract-plugin
export default {"loading":"PageLoading_loading__79J6x","loadingShrink":"PageLoading_loadingShrink__ySOhu"};